import { render, staticRenderFns } from "./DocumentFolderTreeItem.vue?vue&type=template&id=2ef7f065"
import script from "./DocumentFolderTreeItem.vue?vue&type=script&lang=js"
export * from "./DocumentFolderTreeItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentFolderTreeItem.vue?vue&type=style&index=0&id=2ef7f065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports